var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useGlobalContext, parseBoolean } from '@honeycomb/data';
import { TypographyBody, Skeleton, UnsafeHTML } from '@honeycomb/ui-core';
export function HotelSponsoredMessage(_a) {
    var { loading = false } = _a, other = __rest(_a, ["loading"]);
    const { resourceStrings: { SPONSOREDHOTELSMESSAGE }, configSettings: { HCHideSponsoredHotelMessage }, } = useGlobalContext();
    if (parseBoolean(HCHideSponsoredHotelMessage)) {
        return null;
    }
    return (React.createElement(TypographyBody, Object.assign({ component: "div", size: "s" }, other), loading ? React.createElement(Skeleton, { variant: "text", w: 320 }) : React.createElement(UnsafeHTML, null, SPONSOREDHOTELSMESSAGE)));
}
